"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var selectColor = function selectColor(theme, disabled) {
  if (disabled) {
    return theme.colorNeutral15;
  }

  return theme.colorNeutral90;
};

var field = function field(_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  border: none;\n  outline: none;\n  color: ", ";\n  ", ";\n  ::placeholder {\n    color: ", ";\n  }\n  caret-color: ", ";\n  background: transparent;\n\n  ", "\n"])), selectColor(theme, disabled), _styleUtilities.typography['4xl'](theme), theme.colorNeutral15, theme.colorBrandPrimaryLight, _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), _styleUtilities.typography['6xl'](theme)));
};

var Field = _stylitas.styled.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), field);

exports.Field = Field;